// Zinapoya (`TIER`) muharririning SOF mantiqi — React'siz, i18n'siz.
//
// ⚠️ NEGA ALOHIDA FAYL: qorovul testi (`tests/commission-tier.mjs`) shu
// funksiyalarni AYNAN shu yerdan chaqiradi. Tekshiruv mantiqning
// NUSXASI ustida yurmasin — `submitOnValid.ts` bilan bir xil sabab.
//
// ⚠️ XABAR MATNI BU YERDA YO'Q, faqat KOD va QATOR raqami. Yorliq i18n
// lug'atidan keladi (`tests/label-source.mjs` qoidasi), aks holda xato
// matni faqat bitta tilda bo'lardi.

import { moneyFromMajor, type Money } from '@/shared/lib/money'

/** SHARTNOMA §4: kamida 1 pog'ona. */
export const TIER_MIN = 1

/**
 * Ko'pi bilan 50 pog'ona (egasi qarori 2026-08-19, avvalgi chegara 20 edi).
 *
 * ⚠️ Bu BIZNES chegarasi emas — cheksiz o'sishdan himoya. Shuning uchun
 * ekranda oldindan yozilmaydi, faqat chegaraga YETILGANDA aytiladi.
 */
export const TIER_MAX = 50

export const TIER_VALUE_KINDS = ['PERCENT', 'FIXED'] as const
export type TierValueKind = (typeof TIER_VALUE_KINDS)[number]

/**
 * Muharrirdagi BITTA qator. Hamma maydon bo'sh bo'lishi mumkin —
 * qator qo'shilgan zahoti u bo'sh bo'ladi va tekshiruv aynan shu
 * holatni ham aytishi kerak.
 *
 * ⚠️ `upTo` — pog'onaning YUQORI chegarasi va u KIRITILMAYDI
 * (SHARTNOMA §2): «10 000 gacha» → aynan 10 000 KEYINGI pog'onaga
 * tushadi. `null`/`undefined` — «va undan yuqorisi» (oxirgi pog'ona).
 */
export interface TierRow {
  upTo?: Money | null
  valueKind?: TierValueKind | null
  /**
   * FOIZDA (2.5 = 2.5%). Simda bazis punkt bo'ladi — `toDraftTiers` aylantiradi.
   *
   * ⚠️ TIPDA `string` HAM BOR VA BU ROSTNI AYTISH, kengaytma emas
   * (XSB-COM-001). HTML `<input>` ning qiymati HAR DOIM satr, ya'ni
   * `<Input type="number">` bilan chizilgan maydon formaga `"2"`
   * beradi — `2` emas. Ilgari bu yerda faqat `number` deb yozilgandi
   * va tip YOLG'ON edi: `typeof row.percent === 'number'` tekshiruvi
   * har doim `false` chiqib, kiritilgan foiz JIMGINA yo'qolardi.
   * Chegara qiymati {@link toPercentNumber} da normallashtiriladi.
   */
  percent?: number | string | null
  fixed?: Money | null
}

/**
 * Foiz maydonining qiymatini SONGA keltiradi.
 *
 * ⚠️ NEGA BU FUNKSIYA BOR — XSB-COM-001, panelning yagona sababi
 * «komissiya qoidasi kiritilmayapti» nuqsonining.
 *
 * `<Input type="number">` antd'da oddiy `<input>` ustidagi po'stloq:
 * `onChange` `event.target.value` ni beradi va u HAR DOIM SATR. Forma
 * qiymati `"2"` bo'lgani uchun `typeof … === 'number'` tekshiruvi
 * yiqilardi va ikki joyda ikki xil, lekin bir xil darajada jim
 * oqibat berardi:
 *
 *   · `PERCENT` qoidasi: `percentBp` `null` bo'lib ketardi — server
 *     200 qaytarardi, jadvalda esa «0.00%» turardi;
 *   · `TIER` qoidasi: `validateTiers` har foizli qatorga
 *     `valueMissing` yozardi, `okButtonProps.disabled` esa shu
 *     ro'yxatdan hisoblanadi — «Saqlash» tugmasi MANGU o'chiq edi.
 *
 * ⚠️ BO'SH SATR `null`, NOL EMAS: `Number('')` JavaScript'da `0`
 * beradi va u «foiz kiritilmagan» ni «0% komissiya» ga aylantirardi —
 * to'g'ridan-to'g'ri pulda.
 */
export function toPercentNumber(value: number | string | null | undefined): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  if (trimmed === '') return null
  const parsed = Number(trimmed)
  return Number.isFinite(parsed) ? parsed : null
}

/**
 * Foiz maydonidan SIM qiymati (bazis punkt) — `null` bo'sh yoki
 * yaroqsiz kiritishda.
 *
 * ⚠️ MODAL VA YARATISH FORMASI SHU BITTA funksiyani chaqiradi.
 * Aylantirish ikki joyda takrorlansa, bittasida yaxlitlash yoki
 * satr normallashtirish unutilardi va ikki ekran bir xil kiritishdan
 * BOSHQA-BOSHQA foiz yozardi.
 */
export function commissionPercentBp(value: number | string | null | undefined): number | null {
  const percent = toPercentNumber(value)
  return percent === null ? null : percentToBp(percent)
}

export type TierProblemCode =
  | 'empty'
  | 'tooMany'
  | 'valueKindMissing'
  | 'valueMissing'
  | 'percentRange'
  | 'fixedNegative'
  | 'upToNotPositive'
  | 'notIncreasing'
  | 'openTierMissing'
  | 'openTierNotLast'

export interface TierProblem {
  code: TierProblemCode
  /** 1 dan boshlanadigan qator raqami; butun ro'yxatga tegishli bo'lsa `null` */
  row: number | null
}

/**
 * SHARTNOMA §4 ning panel tomonidagi nusxasi. Backend ham AYNAN shuni
 * majburlaydi — bu yerdagi tekshiruv uni almashtirmaydi, faqat
 * operatorga qaysi QATOR xato ekanini so'rovdan OLDIN aytadi.
 *
 * ⚠️ HAMMA muammo qaytariladi, birinchisi emas: operator uchta qatorni
 * ketma-ket to'g'irlab, har safar «yana bittasi bor» degan javob
 * olishi kerak emas.
 */
export function validateTiers(rows: readonly TierRow[]): TierProblem[] {
  const problems: TierProblem[] = []

  if (rows.length < TIER_MIN) return [{ code: 'empty', row: null }]
  if (rows.length > TIER_MAX) problems.push({ code: 'tooMany', row: null })

  rows.forEach((row, index) => {
    const at = index + 1

    if (row.valueKind !== 'PERCENT' && row.valueKind !== 'FIXED') {
      problems.push({ code: 'valueKindMissing', row: at })
    } else if (row.valueKind === 'PERCENT') {
      const percent = toPercentNumber(row.percent)
      if (percent === null) problems.push({ code: 'valueMissing', row: at })
      else if (percent < 0 || percent > PERCENT_MAX) {
        problems.push({ code: 'percentRange', row: at })
      }
    } else {
      if (!row.fixed) problems.push({ code: 'valueMissing', row: at })
      else if (row.fixed.amount < 0) problems.push({ code: 'fixedNegative', row: at })
    }

    // ⚠️ `0` va «bo'sh» ARALASHTIRILMAYDI: nol chegara «hech qanday
    // summa tushmaydigan pog'ona» degani va u xato, bo'sh esa
    // «va undan yuqorisi» — mutlaqo boshqa ma'no.
    if (row.upTo && row.upTo.amount <= 0) problems.push({ code: 'upToNotPositive', row: at })
  })

  for (let i = 1; i < rows.length; i++) {
    const prev = rows[i - 1]?.upTo
    const curr = rows[i]?.upTo
    if (prev && curr && curr.amount <= prev.amount) {
      problems.push({ code: 'notIncreasing', row: i + 1 })
    }
  }

  const openRows = rows.map((r, i) => (r.upTo ? -1 : i)).filter((i) => i >= 0)
  if (openRows.length === 0) {
    problems.push({ code: 'openTierMissing', row: rows.length })
  } else {
    for (const index of openRows) {
      if (index !== rows.length - 1) problems.push({ code: 'openTierNotLast', row: index + 1 })
    }
  }

  return problems
}

/**
 * Chegarasi bitta to'lov limitidan (`PER_TXN`) YUQORI bo'lgan qatorlar.
 *
 * ⚠️ Bu XATO EMAS, ogohlantirish. Zinapoya `PER_TXN` shifti ostida
 * ishlaydi (egasi, 2026-08-19), ya'ni limitdan yuqoridagi pog'onaga
 * hech qachon summa tushmaydi — u o'lik sozlama. Lekin limit
 * ertaga ko'tarilishi mumkin, shuning uchun operatorni TO'SMAYMIZ.
 *
 * Chegara AYNAN limitga TENG bo'lsa o'lik EMAS: `upTo` kiritilmaydi
 * (`summa < upTo`), ya'ni limitgacha bo'lgan summalar shu pog'onada
 * qoladi.
 */
export function deadTierRows(
  rows: readonly TierRow[],
  perTxnLimitMinor: number | null,
): number[] {
  if (perTxnLimitMinor === null || perTxnLimitMinor <= 0) return []
  return rows
    .map((row, index) => (row.upTo && row.upTo.amount > perTxnLimitMinor ? index + 1 : -1))
    .filter((index) => index > 0)
}

/** SHARTNOMA §3 dagi `tiers[]` elementi — DRAFT shakli (`seq` YO'Q). */
export interface CommissionTierDraft {
  upToAmount: Money | null
  percentBp: number | null
  fixedAmount: Money | null
}

/**
 * Foiz FOIZDA kiritiladi, simda BAZIS PUNKT ketadi (250 = 2.5%).
 *
 * ⚠️ `majorToMinor` bilan bir xil sabab uchun `Math.round`: 2.5 * 100
 * JavaScript'da butun chiqadi, 19.99 * 100 esa YO'Q. Yaxlitlamasdan
 * son butun deb serverga ketardi va foiz jimgina siljirdi.
 */
export function percentToBp(percent: number): number {
  return Math.round(percent * 100)
}

/** Bazis punktdan foizga — ekran uchun. */
export function bpToPercent(bp: number): number {
  return bp / 100
}

/**
 * Muharrir qatorlaridan sim shakli.
 *
 * ⚠️ HAR uch kalit HAR DOIM yoziladi va keraksizi ANIQ `null` bo'ladi.
 * Kalitni tashlab ketish «tegilmadi» degan uchinchi ma'noni ochardi —
 * `setAgentLimits` da aynan shu tuzoq hujjatlangan.
 */
export function toDraftTiers(rows: readonly TierRow[]): CommissionTierDraft[] {
  return rows.map((row) => ({
    upToAmount: row.upTo ?? null,
    percentBp: row.valueKind === 'PERCENT' ? commissionPercentBp(row.percent) : null,
    fixedAmount: row.valueKind === 'FIXED' ? (row.fixed ?? null) : null,
  }))
}

/**
 * Foiz maydonining eng katta qiymati — SHARTNOMA §4 dagi
 * `percentBp` 0..10000 ning odam ko'radigan shakli.
 */
export const PERCENT_MAX = 100

/**
 * Bitta to'lov limitining SUKUT qiymati — 100 000 (egasi bergan ANIQ
 * raqam, 2026-08-19), MAJOR birlikda.
 *
 * ⚠️ Bu YAGONA sukut pul qiymati. Zinapoya qiymatlari bo'sh
 * boshlanadi: u yerda hech kim raqam aytmagan va o'ylab topilgan
 * foiz jimgina pulga aylanardi.
 */
export const DEFAULT_PER_TXN_LIMIT_MAJOR = 100000

/**
 * ⚠️ VALYUTA CHAQIRUVCHIDAN, bu yerda mixlanmagan. Egasi «100 000 AFN»
 * dedi va AFN da bu 10 000 000 minor — lekin kasr xonalari boshqa
 * valyutada boshqacha (`currencyExponent`), ya'ni mixlangan minor son
 * boshqa tenantda ming barobar adashardi.
 */
export function defaultPerTxnLimit(currency: string): Money {
  return moneyFromMajor(DEFAULT_PER_TXN_LIMIT_MAJOR, currency)
}
